import React from 'react';
import { Button, ButtonClean, Icon, ModalBox, useModalContext } from '@fourthwall/components';
import { ArrowLongRightIcon, FwIcon, PatreonIcon, TickFilledIcon } from '@fourthwall/icons';
import { useTagManager } from '@hooks/useTagManager';
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop';
import * as S from './styled';
export const PatreonMigrateModal = () => {
    const modal = useModalContext();
    const tagManager = useTagManager();
    const { currentShop } = useCurrentShop();
    return (React.createElement(ModalBox, { title: "Migrate from Patreon to Fourthwall", buttonsDirection: "row", size: "small", onClose: modal.close },
        React.createElement(S.IconsContainer, null,
            React.createElement(S.IconContainer, null,
                React.createElement(Icon, { component: PatreonIcon, height: 32 })),
            React.createElement(S.ArrowIconContainer, null,
                React.createElement(Icon, { component: ArrowLongRightIcon, height: 16 })),
            React.createElement(S.IconContainer, null,
                React.createElement(Icon, { component: FwIcon, height: 32 }))),
        React.createElement("p", null, "We can migrate all your posts, tiers, perks and even tags! Here are key benefits of moving your memberships:"),
        React.createElement(S.List, null,
            React.createElement(S.ListItem, null,
                React.createElement(S.BulletContainer, null,
                    React.createElement(Icon, { component: TickFilledIcon, height: 18 })),
                React.createElement("div", null,
                    React.createElement(S.Bold, null, "Lower fees:"),
                    " Fourthwall takes only 5% from earnings compared to 8% to 12% on Patreon")),
            React.createElement(S.ListItem, null,
                React.createElement(S.BulletContainer, null,
                    React.createElement(Icon, { component: TickFilledIcon, height: 18 })),
                React.createElement("div", null,
                    React.createElement(S.Bold, null, "More customization:"),
                    " Fourthwall offers full control over your members area design, unlike Patreon")),
            React.createElement(S.ListItem, null,
                React.createElement(S.BulletContainer, null,
                    React.createElement(Icon, { component: TickFilledIcon, height: 18 })),
                React.createElement("div", null,
                    React.createElement(S.Bold, null, "All-in-one:"),
                    " Fourthwall combines memberships, merch, and digital sales seamlessly")),
            React.createElement(S.ListItem, null,
                React.createElement(S.BulletContainer, null,
                    React.createElement(Icon, { component: TickFilledIcon, height: 18 })),
                React.createElement("div", null,
                    React.createElement(S.Bold, null, "Standout features:"),
                    " Premium video & audio hosting, polls, DMs, custom apps, discounts, and much more"))),
        React.createElement(ButtonClean, { label: "See full comparision", href: "https://fourthwall.com/compare/fourthwall-vs-patreon-vs-ko-fi?utm_source=patreon-import-theme-editor", target: "_blank", onClick: () => {
                if (!currentShop)
                    return;
                tagManager.trigger('migrate_from_patreon_click', {
                    shop_id: currentShop.id,
                    click_source: 'site_designer_modal',
                    click_destination: 'article',
                });
            } }),
        React.createElement(S.ButtonsContainer, null,
            React.createElement(Button, { label: "Submit import request", appearance: "primary", fullWidth: true, href: "https://share.hsforms.com/1SK-T4WeRQJSIaQy1WW1-NQ552cm", target: "_blank", onClick: () => {
                    if (!currentShop)
                        return;
                    tagManager.trigger('migrate_from_patreon_click', {
                        shop_id: currentShop.id,
                        click_source: 'site_designer_modal',
                        click_destination: 'request_form',
                    });
                } }),
            React.createElement(Button, { label: "Talk to an expert", fullWidth: true, href: "https://meetings.hubspot.com/vince-tumbleson/contentmigration", target: "_blank", onClick: () => {
                    if (!currentShop)
                        return;
                    tagManager.trigger('migrate_from_patreon_click', {
                        shop_id: currentShop.id,
                        click_source: 'site_designer_modal',
                        click_destination: 'book_a_call',
                    });
                } }))));
};
